// Firestore collection constants — maps web-friendly names to actual collection names.
// Phase 2: root user collection is now 'accounts' (stable UUID-keyed, multi-platform).

export const COLLECTIONS = {
  USERS: 'accounts',
  SPOTLIGHT: 'barkBoard',
  FRIENDSHIPS: 'friendships',
  KOKO_INTERACTIONS: 'kokoInteractions',
  KOKO_MEMORY: 'kokoMemory',
  AI_USAGE: 'aiUsage',
  AI_CACHE: 'aiCache',
} as const;

export const SUBCOLLECTIONS = {
  PROFILES: 'profiles',
  BUSINESS_PLANS: 'businessPlans',
  BUSINESSES: 'businesses',
  TOKEN_LEDGER: 'tokenLedger',
  SETTINGS: 'settings',
  SPOTLIGHT_ACTIVITY: 'barkBoardActivity',
  PUBLISHED_POSTS: 'publishedPosts',
  NOTIFICATIONS: 'notifications',
} as const;

// Stage internal keys — match iOS BusinessStage enum
export const STAGES = {
  INTRODUCTION: 'introduction',
  IDEA_EXPLOSION: 'ideaExplosion',
  PROBLEM_SOLVER: 'problemSolver',
  CUSTOMER_DETECTIVE: 'customerDetective',
  MVP_MADNESS: 'mvpMadness',
  MONEY_MOVES: 'moneyMoves',
  COMPETITION_STATION: 'competitionStation',
} as const;

export type StageName = (typeof STAGES)[keyof typeof STAGES];
